import { BASE_URL } from '@avanta/shared/constants/common';
import { service, type ServiceRequestConfig } from '@avanta/shared/services/api';
import { type AxiosResponse } from 'axios';
import {
  type GetActivePatientRecordParams,
  type GetPatientRecordsParams,
  type PatientRecord,
} from 'types/patient';

const PATIENTS_URL = `${BASE_URL}patients`;

type PatientServiceTypes = {
  getActiveRecord: (
    patientId: string,
    params?: GetActivePatientRecordParams
  ) => Promise<AxiosResponse<PatientRecord | ''>>;
  getRecords: (
    patientId: string,
    params?: GetPatientRecordsParams
  ) => Promise<AxiosResponse<PatientRecord[]>>;
};

export const PatientService: PatientServiceTypes = {
  getActiveRecord: async (patientId, params) => {
    const config: ServiceRequestConfig = {
      params,
      skipGlobalErrorHandler: true,
      validateStatus: status => (status >= 200 && status < 300) || status === 406 || status === 409,
    };
    return service.get(`${PATIENTS_URL}/${patientId}/records/active`, config);
  },
  getRecords: async (patientId, params) => {
    const config: ServiceRequestConfig = {
      params,
      skipGlobalErrorHandler: true,
      validateStatus: status => (status >= 200 && status < 300) || status === 406,
    };
    return service.get(`${PATIENTS_URL}/${patientId}/records`, config);
  },
};
